module.exports = __webpack_public_path__ + "static/media/Gallery.3adfdd71.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Gallery/Gallery.scss
// module id = 106
// module chunks = 0